export const useBrowserStorage = <T>(
  key: string,
  serializer: (value: T) => string,
  deserielizer: (str: string) => T,
  isSession = false
) => {
  const storage = isSession ? window.sessionStorage : window.localStorage;
  const setValue = (value: T) => {
    const str = serializer(value);
    storage.setItem(key, str);
  };
  const getValueStr = () => {
    const strOpt = storage.getItem(key);
    if (strOpt === null) {
      return undefined;
    }
    return strOpt;
  };
  const getValue = () => {
    const strOpt = getValueStr();
    return strOpt !== undefined ? deserielizer(strOpt) : undefined;
  };
  const deleteValue = () => {
    storage.removeItem(key);
  };
  return {
    setValue,
    getValue,
    deleteValue,
    getValueStr,
    serializer,
    deserielizer,
  };
};
